import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import SSwitch from '../Switch'
import Popover from '@mui/material/Popover'
import Button from '@mui/material/Button'
import { Box } from '@mui/material'
import { useState } from 'react'

export const CellActions = (cellValue, handleActionsClick) => {
  const isOn = cellValue.row.enabled
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleConfirmArchive = () => {
    handleActionsClick.archiveRule(cellValue)
    handleClose()
  }

  const open = Boolean(anchorEl)

  return (
    <Stack spacing={1} direction={{ sm: 'row', xs: 'row' }} justifyContent='center' alignItems='flex-start'>
      <Box sx={{ m: -10 }}>
        <Tooltip title={`Press to ${isOn ? 'Deactivate' : 'Activate'}`}>
          <span>
            <SSwitch actions={handleActionsClick} cell={cellValue} />
          </span>
        </Tooltip>
        <Tooltip title={'Archive'}>
          <span>
            <IconButton
              onClick={handleClick}
              size={'small'}
              style={{ margin: '0 8px' }}
            // disabled={cell.botsType === ARCHIVED}
            >
              <i className={`fas fa-archive blue`} />
            </IconButton>
          </span>
        </Tooltip>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Box sx={{ p: 2 }}>
            <div>Archive this rule?</div>
            <Button onClick={handleConfirmArchive} size="small">Confirm</Button>
          </Box>
        </Popover>

        <Tooltip title='Edit'>
          <span>
            <IconButton
              onClick={(e) => {
                e.preventDefault()
                handleActionsClick.editRuleOpen(cellValue)
              }}
              size={'small'}
              style={{ margin: '1px' }}
            >
              <i className='fas fa-pen' />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Stack>
  )
}
